'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _last2 = require('lodash/last');

var _last3 = _interopRequireDefault(_last2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PlayStatsColumnChart = require('components/Statistics/PlayStatsChart/PlayStatsColumnChart');

var _PlayStatsColumnChart2 = _interopRequireDefault(_PlayStatsColumnChart);

var _PlayStatsLineChart = require('components/Statistics/PlayStatsChart/PlayStatsLineChart');

var _PlayStatsLineChart2 = _interopRequireDefault(_PlayStatsLineChart);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var longPeriodDuration = 60 * 60 * 24 * 6; //seconds


var PlayStatsChart = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(PlayStatsChart, _PureComponent);

  function PlayStatsChart() {
    (0, _classCallCheck3.default)(this, PlayStatsChart);
    return (0, _possibleConstructorReturn3.default)(this, (PlayStatsChart.__proto__ || (0, _getPrototypeOf2.default)(PlayStatsChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlayStatsChart, [{
    key: 'getDaysCount',
    value: function getDaysCount() {
      var data = this.props.data;

      return data.length ? _moment2.default.duration((0, _last3.default)(data).unixDate - data[0].unixDate, 'seconds').asDays() + 1 : 0;
    }
  }, {
    key: 'isPeriodLong',
    value: function isPeriodLong() {
      var data = this.props.data;

      if (!data.length) {
        return false;
      }

      var chartPeriod = (0, _last3.default)(data).unixDate - data[0].unixDate;
      return chartPeriod > longPeriodDuration;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          id = _props.id,
          loading = _props.loading,
          chartOptions = _props.chartOptions;

      var isPeriodLong = this.isPeriodLong();
      var daysCount = this.getDaysCount();
      var props = { data: data, id: id, daysCount: daysCount, loading: loading, chartOptions: chartOptions };

      return isPeriodLong ? _react2.default.createElement(_PlayStatsLineChart2.default, props) : _react2.default.createElement(_PlayStatsColumnChart2.default, props);
    }
  }]);
  return PlayStatsChart;
}(_react.PureComponent), _class.propTypes = {
  chartOptions: _propTypes2.default.object,
  data: _propTypes2.default.array,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool
}, _class.defaultProps = {
  data: []
}, _temp);
exports.default = PlayStatsChart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/PlayStatsChart/PlayStatsChart.js
// module id = 521
// module chunks = 1